const DEFAULT_PLACEHOLDER_IMAGE = 'http://qiniu.dddog.com.cn/200.jpg' // 展位图

export default {
  data() {
    return {
      loading: true
    }
  },
  props: {
    src: {
      type: String
    },
    placeholderImage: {
      type: String,
      default: DEFAULT_PLACEHOLDER_IMAGE
    },
    direction: {
      type: String,
      default: 'vertical'
    },
    viewport: {
      type: typeof window !== 'undefined' ? window.HTMLElement : Object,
      default: () => null
    },
    threshold: {
      type: String,
      default: '0px'
    }
  },
  async mounted() {
    if (!this.timeout) {
      // 根据滚动方向来构造视口外边距，用于提前加载
      let rootMargin
      switch (this.direction) {
        case 'vertical':
          rootMargin = `${this.threshold} 0px`
          break
        case 'horizontal':
          rootMargin = `0px ${this.threshold}`
          break
      }
      if (!window.IntersectionObserver) await import('intersection-observer')
      // 观察视口与组件容器的交叉情况
      this.io = new window.IntersectionObserver(this.intersectionHandler, {
        rootMargin,
        root: this.viewport,
        threshold: [ 0, Number.MIN_VALUE, 0.01 ]
      })
      this.io.observe(this.$el)
    }
  },
  beforeDestroy() {
    // 在组件销毁前取消观察
    if (this.io) {
      this.io.unobserve(this.$el)
    }
  },
  methods: {
    // 交叉情况变化处理函数
    intersectionHandler(entries) {
      // 正在交叉 || 交叉率大于0
      if (entries[0].isIntersecting || entries[0].intersectionRatio) {
        this.loading = false
        this.io.unobserve(this.$el)
      }
    }
  },
  render(h) {
    return (
      <img src={this.loading ? this.placeholderImage : this.src} data-src={this.src} />
    )
  }
}